/**
 * @generated SignedSource<<77def64264ce451c318673b12eaa8861>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HighLevelTimeNumbers_project$data = {
  readonly id: string;
  readonly useBaseline: boolean | null;
  readonly billable: boolean | null;
  readonly financialNumbers: {
    readonly registeredMinutes: number | null;
    readonly billableActualMinutes: number | null;
    readonly nonBillableActualMinutes: number | null;
    readonly forecastMinutes: number | null;
    readonly baselineMinutes: number | null;
    readonly scopeApprovedMinutes: number | null;
    readonly projectedTotalMinutes: number | null;
    readonly projectedBillableMinutes: number | null;
    readonly projectedNonBillableMinutes: number | null;
  } | null;
  readonly " $fragmentType": "HighLevelTimeNumbers_project";
};
export type HighLevelTimeNumbers_project$key = {
  readonly " $data"?: HighLevelTimeNumbers_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"HighLevelTimeNumbers_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HighLevelTimeNumbers_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "useBaseline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "billable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "convertToProjectCurrency",
          "value": true
        }
      ],
      "concreteType": "FinancialNumbers",
      "kind": "LinkedField",
      "name": "financialNumbers",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "registeredMinutes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "billableActualMinutes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nonBillableActualMinutes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "forecastMinutes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "baselineMinutes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "scopeApprovedMinutes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectedTotalMinutes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectedBillableMinutes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectedNonBillableMinutes",
          "storageKey": null
        }
      ],
      "storageKey": "financialNumbers(convertToProjectCurrency:true)"
    }
  ],
  "type": "ProjectType",
  "abstractKey": null
};

(node as any).hash = "fe26c4ae7d588ad1ab924c666de5f876";

export default node;
